<template>
  <div class="container-fluid hero-section">
    <div
      class="row h-100 py-5 align-items-center justify-content-center text-center"
    >
      <div class="col-md-7 pb-5 mb-5">
        <h1 data-aos="fade-up" data-aos-duration="1800">
          Preserve the <span class="first-gradient">essence</span> <br />
          of your family <span class="second-gradient">culture</span>
        </h1>
        <p
          class="col-md-9 mx-auto fs-21"
          data-aos="fade-up"
          data-aos-duration="2500"
        >
          Kinfolk helps families to stay connected, preserve their family
          history and memories, and track their lineage.
        </p>
        <a
          href="#"
          class="btn signature-btn mt-5"
          data-aos="fade-up"
          data-aos-duration="3000"
          >Get started</a
        >
      </div>
    </div>
  </div>
  <section class="about-section">
    <div class="container py-5">
      <div class="row py-5 h-100 align-items-center">
        <div class="col-md-6">
          <img
            data-aos="fade-up"
            data-aos-duration="3000"
            class="w-100"
            src="../assets/images/about.png"
            alt=""
          />
        </div>
        <div class="col-md-6">
          <h3 class="fs-38 mt-md-0 mt-4">
            Create a rich, interactive family history that captures your
            family's stories and traditions for generations to come!
          </h3>
          <p class="col-md-10">
            KinFolk is a family connection app that goes beyond just building a
            family tree. With features for storytelling, event planning, shared
            calendars, and video conferencing, KIN is designed to bring families
            closer together.
          </p>
          <a href="#" class="btn cta w-auto">Learn more</a>
        </div>
      </div>
    </div>
  </section>
  <div class="container features-section py-5">
    <div class="row py-md-5 h-100 align-items-top">
      <div class="col-md-12 pb-4">
        <h1
          class="text-center fs-58"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          Kinfolk’s amazing features
        </h1>
      </div>
      <div class="col-md-3" data-aos="fade-up" data-aos-duration="1000">
        <div class="card text-center bg-white">
          <div class="card-header">
            <img src="../assets/images/family-event.png" alt="Family Events" />
          </div>
          <div class="card-body">
            <h5>Family Events</h5>
            <p>
              Plan and organize family gatherings while creating a lasting
              record of the event.
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-3" data-aos="fade-up" data-aos-duration="1500">
        <div class="card text-center bg-white">
          <div class="card-header">
            <img
              src="../assets/images/bulletin-board.png"
              alt="Bulletin Board"
            />
          </div>
          <div class="card-body">
            <h5>Bulletin Board</h5>
            <p>Share important updates with your family members, .</p>
          </div>
        </div>
      </div>
      <div class="col-md-3" data-aos="fade-up" data-aos-duration="2000">
        <div class="card text-center bg-white">
          <div class="card-header">
            <img src="../assets/images/family-tree.png" alt="Family Tree" />
          </div>
          <div class="card-body">
            <h5>Family Tree</h5>
            <p>Build out your family tree network when you invite new kin.</p>
          </div>
        </div>
      </div>
      <div class="col-md-3" data-aos="fade-up" data-aos-duration="2500">
        <div class="card text-center bg-white">
          <div class="card-header">
            <img src="../assets/images/folklore.png" alt="Folklore Events" />
          </div>
          <div class="card-body">
            <h5>Folklore</h5>
            <p>
              Record and preserve customs, stories, and cultural practices
              through audio conversations.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container be-apart-section p-md-5 p-4 my-5">
    <div class="row h-100 p-md-4 align-items-center">
      <div class="col-md-6">
        <h3 class="fs-34">Be part of something bigger:</h3>
        <ol>
          <li>
            By preserving family memories and traditions, Kin can help users
            reflect on their roots and identity, providing a sense of meaning
            and purpose. Reflecting on our personal history and values can give
            us a greater sense of fulfillment and direction in life.
          </li>
          <li>
            Legacy: By creating a rich, interactive family history, Kin allows
            users to leave a lasting legacy for future generations. Knowing that
            our stories and traditions will be passed down can give us a sense
            of fulfillment and purpose, knowing that we are contributing to
            something larger than ourselves.
          </li>
        </ol>
        <a href="#" class="btn cta w-auto">Learn more</a>
      </div>
      <div class="col-md-6 mt-md-0 mt-5">
        <img
          class="w-100"
          data-aos="fade-up"
          data-aos-duration="2500"
          src="../assets/images/be-apart.png"
          alt="Be a part of something bigger"
        />
      </div>
    </div>
  </div>
  <div class="py-4"></div>
  <div class="container-fluid legacy-section p-x-5 px-4 mt-5">
    <div class="row h-100 align-items-center">
      <div class="col-md-12">
        <h1 class="text-center fs-58">
          With KinFolk you leave a lasting legacy
        </h1>
      </div>
    </div>
  </div>
  <div class="container-fluid pricing-section px-md-5 pblock100 mb-5">
    <div class="row h-100 py-5 align-items-center">
      <div
        class="col-md-6 mx-auto text-center text-white"
        data-aos="fade-up"
        data-aos-duration="1800"
      >
        <h3 class="fs-38">Simple pricing, for everyone</h3>
        <p class="fs-21 aonik-light">
          KinFolk subscription plan per month for households or users who wish
          to add a descendant to their account.
        </p>
      </div>
      <div class="col-md-7 mx-auto text-center text-white">
        <packages />
      </div>
    </div>
  </div>
  <Faq />
 
</template>


<script>
import Packages from "./Packages.vue";
import Faq from "./Faq.vue";
export default {
  components: { Packages, Faq },
  name: "Home",
  props: {
    msg: String,
  },
  data() {
    return {
      pageTitle: 'Kinfolk',
    };
  },
  mounted() {
    document.title = this.pageTitle;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
